module.exports = __webpack_public_path__ + "img/Fenêtre pvc.5ca2bb17.jpg";